import { useState } from 'react'

import { Form } from 'factorial-form'
import { type ResourceFieldDataFragment, ValueDataFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'

import { createForm } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/createForm'
import type { CustomFieldAttributes } from 'modules/timeoff/lib/DocumentForm'

const createFieldsForms = (
  customResourceFieldsData: ResourceFieldDataFragment[],
  customValuesData?: ValueDataFragment[]
): Form[] => {
  const editableCustomResourceFields = customResourceFieldsData.filter(
    ({ field }) => field?.editable
  )

  return editableCustomResourceFields.map((customResourceField) => {
    const customValue = customValuesData?.find(
      (value) => value.fieldId === customResourceField.field?.id
    )
    return createForm(customResourceField, customValue)
  })
}

const useCustomFields = ({
  customResourceFieldsData,
  customValuesData,
}: {
  customResourceFieldsData: ResourceFieldDataFragment[]
  customValuesData?: ValueDataFragment[]
}) => {
  const [forms, setForms] = useState<Form[]>([])

  useEffect(() => {
    setForms(createFieldsForms(customResourceFieldsData, customValuesData))
  }, [customResourceFieldsData.length, customValuesData?.length])

  const getValues: () => CustomFieldAttributes[] = () => {
    return forms.map((form) => {
      const { resource_field_id, value } = form.data()
      return {
        resource_id: resource_field_id,
        value,
      }
    })
  }

  return {
    forms,
    getValues,
  }
}

export default useCustomFields
